import { Alcohol } from "../models/Alcohol";

export const AlcoholSortableKeys: Array<keyof Alcohol> = [
  "name",
  "alcohol",
  "energy_value_kj",
  "energy_value_kcal",
  "fat",
  "saturated_fatty_acids",
  "carbohydrates",
  "sugars",
  "protein",
  "salt",
];
